import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
})

export const adminLogin = async (email, password) => {
    const response = await axiosInstance.post('/api/v1/auth/admin-login', {
        email,
        password
    });

    if (response.data.access_token) {
        localStorage.setItem('token', response.data.access_token);
    }
}

export const createCourse = async (createCourseData) => {
    const token = localStorage.getItem('token')
    await axiosInstance.post('/api/v1/interactive-course/create', {
        ...createCourseData
    }, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
}
export const getListOfCourses = async () => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.get('/api/v1/interactive-course/list', {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const getCourseDetail = async (courseId) => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.get(`/api/v1/interactive-course/course-detail/${courseId}`, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const updateCourse = async (courseId, updateCourseData) => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.post(`/api/v1/interactive-course/course-update/${courseId}`, {
        ...updateCourseData
    }, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}


export const contactUs = async ({ name, email, topic, description }) => {
    const response = await axiosInstance.post('/api/v1/users/contact-us', {
        name,
        email,
        topic,
        description
    });

    if (response.data.access_token) {
        localStorage.setItem('token', response.data.access_token);
    }
}

export const getMatesList = async () => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.get('/api/v1/ai-practice/mates-list', {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const getMateDetail = async (mateId) => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.get(`/api/v1/ai-practice/mate-detail/${mateId}`, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const updateMate = async (mateId, updateMateData) => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.post(`/api/v1/ai-practice/mate-update/${mateId}`, {
        ...updateMateData
    }, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const requestDeleteData = async ({ email, description }) => {
    const response = await axiosInstance.post('/api/v1/users/delete-account', {
        email,
        description
    });
    return response.data;
}

export const getAllPersonalCollections = async () => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.get('/api/v1/personal-set/my/all', {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const getCollectionDetail = async (id) => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.get(`/api/v1/personal-set/${id}`, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const createPersonalCollection = (data) => {
    return axiosInstance.post(`/api/v1/personal-set`, data, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });
};

// dodo here new api methods for hadle chats
export const getChatList = async () => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.get('/api/v1/ai-practice/chat-list', {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const getChatConfigDetail = async (id) => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.get(`/api/v1/ai-practice/config-detail/${id}`, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}


export const resetChats = async () => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.post('/api/v1/ai-practice/test/reset-mates', {}, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const createDefault = async () => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.post('/api/v1/ai-practice/test/default-mates', {}, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const getChatMessages = async (id) => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.get(`/api/v1/ai-practice/message-list/${id}`, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const getAgentMemory = async (chatId) => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.post('/api/v1/ai-example/agent-memory', {
        chat_id: chatId
    }, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const getDailyPhrasesList = async () => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.get('/api/v1/daily-phrase/full', {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const getDailyPhraseDetail = async (id) => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.get(`/api/v1/daily-phrase/${id}`, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const getAudioUrl = async (fileId) => {
    const token = localStorage.getItem('token')
    const response = await axiosInstance.get(`/api/v1/voicing/voice-tutorial-message/${fileId}`, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data.url;
}

export const generatePhraseAudio = async (id) => {
    const token = localStorage.getItem('token');
    const response = await axiosInstance.post(`/api/v1/daily-phrase/phrase_audio/${id}`, {}, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const generateExampleAudio = async (id) => {
    const token = localStorage.getItem('token');
    const response = await axiosInstance.post(`/api/v1/daily-phrase/example_audio/${id}`, {}, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data;
}

export const getImageUrl = async (fileId) => {
    const token = localStorage.getItem('token');
    // If it's already a full HTTP URL, just return it
    if (fileId.startsWith('http://') || fileId.startsWith('https://')) {
        return fileId;
    }
    const response = await axiosInstance.get(`/api/v1/bucket/images/${fileId}`, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    return response.data.url;
}

// Resource / Source API endpoints
export const getResources = async (type = '') => {
    const token = localStorage.getItem('token');
    const headers = { "Authorization": `Bearer ${token}` };
    const params = type && type !== 'all' ? { type } : {};
    try {
        const response = await axiosInstance.get('/api/v1/resource', { params, headers });
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 404) {
            const response = await axiosInstance.get('/resource', { params, headers });
            return response.data;
        }
        throw err;
    }
};

export const getResourcesByType = async (type) => {
    const token = localStorage.getItem('token');
    const headers = { "Authorization": `Bearer ${token}` };
    try {
        const response = await axiosInstance.get(`/api/v1/resource/type/${type}`, { headers });
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 404) {
            const response = await axiosInstance.get(`/resource/type/${type}`, { headers });
            return response.data;
        }
        throw err;
    }
};

export const createResource = async (createData) => {
    const token = localStorage.getItem('token');
    const headers = { "Authorization": `Bearer ${token}` };
    try {
        const response = await axiosInstance.post('/api/v1/resource', createData, { headers });
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 404) {
            const response = await axiosInstance.post('/resource', createData, { headers });
            return response.data;
        }
        throw err;
    }
};

export const deleteResource = async (id) => {
    const token = localStorage.getItem('token');
    const headers = { "Authorization": `Bearer ${token}` };
    try {
        const response = await axiosInstance.delete(`/api/v1/resource/${id}`, { headers });
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 404) {
            const response = await axiosInstance.delete(`/resource/${id}`, { headers });
            return response.data;
        }
        throw err;
    }
};

export const updateResource = async (id, updateData) => {
    const token = localStorage.getItem('token');
    const headers = { "Authorization": `Bearer ${token}` };
    try {
        const response = await axiosInstance.put(`/api/v1/resource/source-edit/${id}`, updateData, { headers });
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 404) {
            try {
                const response = await axiosInstance.put(`/resource/source-edit/${id}`, updateData, { headers });
                return response.data;
            } catch (err2) {
                if (err2.response && err2.response.status === 404) {
                    try {
                        const response = await axiosInstance.put(`/api/v1/resource/${id}`, updateData, { headers });
                        return response.data;
                    } catch (err3) {
                        if (err3.response && err3.response.status === 404) {
                            const response = await axiosInstance.put(`/resource/${id}`, updateData, { headers });
                            return response.data;
                        }
                        throw err3;
                    }
                }
                throw err2;
            }
        }
        throw err;
    }
};

export const getUsersStatistic = async () => {
    const token = localStorage.getItem('token');
    const headers = { "Authorization": `Bearer ${token}` };
    try {
        const response = await axiosInstance.get('/api/v1/statistic/users', { headers });
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 404) {
            const response = await axiosInstance.get('/v1/statistic/users', { headers });
            return response.data;
        }
        throw err;
    }
};

export const getRegistrationStatistic = async () => {
    const token = localStorage.getItem('token');
    const headers = { "Authorization": `Bearer ${token}` };
    try {
        const response = await axiosInstance.get('/api/v1/statistic/registrations', { headers });
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 404) {
            const response = await axiosInstance.get('/v1/statistic/registrations', { headers });
            return response.data;
        }
        throw err;
    }
};

export const getFeedbacks = async () => {
    const token = localStorage.getItem('token');
    const headers = { "Authorization": `Bearer ${token}` };
    try {
        const response = await axiosInstance.get('/api/v1/admin/feedbacks', { headers });
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 404) {
            const response = await axiosInstance.get('/admin/feedbacks', { headers });
            return response.data;
        }
        throw err;
    }
};
